import { TmApiUserBlockedError } from '@/core/error/transport/tmApiUserBlockedError'

export class TmAuthPendingFraudError extends TmApiUserBlockedError {
  public name = 'TmAuthPendingFraudError'
}
